import { parseToml } from './toml.js';
import type { TimezoneEntry, CityEntry, DataMeta, AppState } from './types.js';

async function loadTomlFile(filename: string): Promise<Record<string, unknown>> {
  const response = await fetch(`data/${filename}`);
  if (!response.ok) {
    throw new Error(`Failed to load ${filename}: ${response.status} ${response.statusText}`);
  }
  const text = await response.text();
  return parseToml(text);
}

export async function loadAllData(): Promise<AppState> {
  const [timezonesDoc, citiesDoc, metaDoc] = await Promise.all([
    loadTomlFile('timezones.toml'),
    loadTomlFile('cities.toml'),
    loadTomlFile('_meta.toml'),
  ]);

  const timezones = (timezonesDoc['timezones'] as Array<Record<string, unknown>>).map(
    (tz): TimezoneEntry => ({
      id: tz['id'] as string,
      name: tz['name'] as string,
      utc_offset: tz['utc_offset'] as number,
      dst: tz['dst'] as boolean,
      dst_start: tz['dst_start'] as string | undefined,
      dst_end: tz['dst_end'] as string | undefined,
      dst_offset: tz['dst_offset'] as number | undefined,
      abbr: tz['abbr'] as string,
      abbr_dst: tz['abbr_dst'] as string | undefined,
    })
  );

  const cities = (citiesDoc['cities'] as Array<Record<string, unknown>>).map(
    (c): CityEntry => ({
      name: c['name'] as string,
      country: c['country'] as string,
      timezone: c['timezone'] as string,
    })
  );

  const meta: DataMeta = {
    last_updated: metaDoc['last_updated'] as string,
    data_sources: metaDoc['data_sources'] as string[],
  };

  return { timezones, cities, meta };
}